import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X } from "lucide-react";
import ContactForm from "../frontend/ContactForm";

const AutoContactPopup = () => {
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const hasSeenPopup = sessionStorage.getItem("hasSeenContactPopup");
        if (!hasSeenPopup) {
            const timer = setTimeout(() => {
                setIsOpen(true);
                sessionStorage.setItem("hasSeenContactPopup", "true");
            }, 10000);
            return () => clearTimeout(timer);
        }
    }, []);

    // Lock scroll but allow touch interaction
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => { document.body.style.overflow = ""; };
    }, [isOpen]);

    return (
        <AnimatePresence>
            {isOpen && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 sm:p-6">
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        exit={{ opacity: 0 }}
                        onClick={() => setIsOpen(false)}
                        className="absolute inset-0 bg-black/80 backdrop-blur-md"
                    />

                    <motion.div
                        initial={{ opacity: 0, scale: 0.9, y: 20 }}
                        animate={{ opacity: 1, scale: 1, y: 0 }}
                        exit={{ opacity: 0, scale: 0.9, y: 20 }}
                        /*
                           FIX: max-h-[92dvh] ensures it fits all iPhones perfectly
                           even when the Safari address bar is visible.
                        */
                        className="relative w-full max-w-lg bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800 rounded-[2rem] shadow-2xl overflow-hidden flex flex-col max-h-[92dvh] border border-white/10"
                    >
                        {/* HEADER */}
                        <div className="flex items-center justify-between px-6 py-5 border-b border-white/5 bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-800  z-20">
                            <div>
                                <h3 className="text-xl font-bold text-slate-700 dark:text-slate-300 tracking-tight">Let's Talk Strategy</h3>
                                <p className="text-xs text-gray-500 mt-0.5">Quick response guaranteed.</p>
                            </div>
                            <button
                                onClick={() => setIsOpen(false)}
                                className="p-2.5 rounded-full bg-white/5 text-gray-400 hover:text-white transition-colors"
                            >
                                <X className="w-5 h-5 text-slate-700 dark:text-slate-300" />
                            </button>
                        </div>

                        {/* SCROLLABLE BODY (Integrated Form) */}
                        <div className="flex-1 overflow-y-auto no-scrollbar px-6 py-6 sm:px-8">
                            {/*
                               Pass the 'isMinimal' prop to remove the inner box styling.
                               This makes the form look like it belongs to the modal.
                            */}
                            <ContactForm isMinimal={true} />

                            {/* FOOTER AREA */}
                            <div className="mt-10 pb-4 border-t border-white/5 pt-6 text-center">
                                <div className="flex items-center justify-center gap-2 mb-2">
                                    <span className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-pulse" />
                                    <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-gray-500">
                                        Secure & Confidential
                                    </span>
                                </div>
                                <p className="text-[10px] text-gray-600">
                                    We respect your privacy. No spam, ever.
                                </p>
                            </div>
                        </div>
                    </motion.div>
                </div>
            )}
        </AnimatePresence>
    );
};

export default AutoContactPopup;